import { NgModule } from "@angular/core";
import { Routes } from "@angular/router";
import { MarkdownModule } from "ngx-markdown";
import { AuthGuardService } from "app/shared/auth-guard.service";
import { SharedModule } from "app/shared/shared.module";
import { DocManagerComponent } from "./doc-manager.component";
import { InvoicePdfPortalDocComponent } from "./invoice-pdf-portal-doc.component";
import { QuickbooksIntegrationDocComponent } from "./quickbooks-integration-doc.component";
import { TokenManagementDocComponent } from "./token-management-doc.component";
import { ScaleIntegrationDocComponent } from "./scale-integration-doc.component";

export const routes: Routes = [
  {
    path: "tech-docs",
    canActivate: [AuthGuardService],
    children: [
      {
        path: "",
        redirectTo: "manage",
        pathMatch: "full",
      },
      {
        path: "manage",
        canActivate: [AuthGuardService],
        component: DocManagerComponent,
        data: { breadcrumb: "Technical Documentation" },
        children: [
          {
            path: "",
            redirectTo: "invoice-pdf-portal",
            pathMatch: "full",
          },
          {
            path: "invoice-pdf-portal",
            component: InvoicePdfPortalDocComponent,
            data: { breadcrumb: "Invoice PDF Portal" },
          },
          {
            path: "quickbooks-integration",
            component: QuickbooksIntegrationDocComponent,
            data: { breadcrumb: "QuickBooks Integration" },
          },
          {
            path: "token-management",
            component: TokenManagementDocComponent,
            data: { breadcrumb: "Token Management" },
          },
          {
            path: "scale-integration",
            component: ScaleIntegrationDocComponent,
            data: { breadcrumb: "Scale Integration" },
          },
        ],
      },
    ],
  },
];

@NgModule({
  declarations: [DocManagerComponent, InvoicePdfPortalDocComponent, QuickbooksIntegrationDocComponent, TokenManagementDocComponent, ScaleIntegrationDocComponent],
  imports: [SharedModule, MarkdownModule.forChild()],
})
export class DocumentationModule {}
